export const calculateTotals = (quantities, dishes) => {
  let SubTotal = 0;

  for (let i = 0; i < quantities.length; i++) {
    const qty = quantities[i] ?? 0;
    const price = dishes[i]?.price ?? 0;
    SubTotal += qty * price;
  }

  const serviceCharge = SubTotal * 0.1;
  const totalPriceWithServiceCharge = SubTotal + serviceCharge;

  return { SubTotal, serviceCharge, totalPriceWithServiceCharge };
};

export const calculateTotalAmountFromEveryone = (eachPersonBillSummary) => {
  return eachPersonBillSummary.reduce(
    (sum, p) => sum + (p.onePersonBillSummary ?? 0),
    0
  );
};
